export const NONE = 'none';
export const FEMALE = 'female';
export const MALE = 'male';
export const DIFFICULTY_BREATHING = 'Difficulty breathing';
export const RED = 'RED';
export const ORANGE = 'ORANGE';
export const YELLOW = 'YELLOW';
export const GREEN = 'GREEN';
export const NOT_KNOW = `I don't know`
export const DAILY_CHECKIN_QUESTIONS_COUNT = 7;
export const QUESTIONS_COUNT = 12;